import { render, staticRenderFns } from "./main-navigation.vue?vue&type=template&id=6e5fb1cb&scoped=true&"
import script from "./main-navigation.ts?vue&type=script&lang=ts&"
export * from "./main-navigation.ts?vue&type=script&lang=ts&"
import style0 from "./main-navigation.scss?vue&type=style&index=0&id=6e5fb1cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5fb1cb",
  null
  
)

component.options.__file = "main-navigation.vue"
export default component.exports